import axios from "axios";
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});
axiosInstance.interceptors.request.use((request) => {
  // add auth header with jwt if account is logged in
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");
  // const publicId = JSON.parse(storedUser)?.public_id;

  if (token) {
    request.headers.common["x-access-token"] = token;
    // request.headers.common["x-id"] = publicId;
  }
  return request;
});

const responseSuccessHandler = (response) => {
  return response;
};

//   const responseErrorHandler = error => {
//     if (error.response.status === 401) {
//         localStorage.removeItem('token')
//         localStorage.removeItem('user')
//         window.location='/login'
//     }

//     return Promise.reject(error);
//   };

axiosInstance.interceptors.response.use(
  (response) => responseSuccessHandler(response)
  // error => responseErrorHandler(error)
);

export default axiosInstance;
